module.exports = __webpack_public_path__ + "static/assets/99a379073e606313f5606bfb2f216d6e.svg";